module.exports = __webpack_public_path__ + "img/taiping.0d435f0a.png";